import type { JSX } from 'react';
import { Seo } from '@/components/seo';
import { ShowingsAvailabilityManager } from '@/components/dashboard/showings/ShowingsAvailabilityManager';

export function DashboardShowingAvailability(): JSX.Element {
  return (
    <section className="flex flex-col gap-xl py-8">
      <Seo
        title="Showing Availability"
        description="Define global showing availability windows for scheduling showings."
        canonicalPath="/dashboard/showings/availability"
        noIndex
      />

      <header className="flex flex-col gap-xs">
        <h1 className="text-2xl font-semibold text-brand-primary md:text-3xl">
          Showing Availability
        </h1>
        <p className="text-sm text-text-primary/70">
          Manage global availability used when scheduling showings. Default is weekdays,
          9:00am-5:00pm.
        </p>
      </header>

      <ShowingsAvailabilityManager />
    </section>
  );
}
